module.exports = new __parcel__URL__("industrial.ab95c64d.jpg").toString();